import axios from "axios";
import API_URLS from "../../../config/global_variables";

const authToken = () => {
  try {
    return JSON.parse(localStorage.userData || "{}").token || "";
  } catch {
    return "";
  }
};

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: authToken(),
});

const ERROR_MESSAGES = {
  VALIDATION_ERROR: "Please fix the highlighted fields.",
  NOT_FOUND: "Bucket not found — it may have been deleted in another tab.",
  DUPLICATE_KEY: "A bucket with this key already exists for this store.",
  REFERENCED: "Cannot delete — this bucket is in use.",
  SERVER_ERROR: "Something went wrong. Please try again.",
};

const mapError = (err) => {
  const apiErr = err?.response?.data?.error;
  const code = apiErr?.code;
  const status = err?.response?.status;
  const fallback =
    apiErr?.message ||
    (status ? `Request failed (${status})` : err?.message || ERROR_MESSAGES.SERVER_ERROR);
  let message = ERROR_MESSAGES[code] || fallback;
  if (code === "VALIDATION_ERROR" && Array.isArray(apiErr?.details) && apiErr.details.length) {
    message = apiErr.details
      .map((d) => `${d.path || "field"}: ${d.message}`)
      .join("\n");
  } else if (code === "REFERENCED" && Array.isArray(apiErr?.details) && apiErr.details.length) {
    message = apiErr.details
      .map((d) => `${d.table || "table"}: ${d.count ?? "?"}`)
      .join(", ");
    message = `${ERROR_MESSAGES.REFERENCED} (${message})`;
  }
  return {
    code: code || (status ? `HTTP_${status}` : "NETWORK_ERROR"),
    status,
    message,
    details: apiErr?.details || [],
  };
};

const buildListParams = (filters = {}) => {
  const params = {};
  if (filters.store_hash) params.store_hash = filters.store_hash;
  if (filters.is_active !== undefined && filters.is_active !== null && filters.is_active !== "")
    params.is_active = filters.is_active;
  if (filters.search) params.search = filters.search;
  if (filters.sort_by) params.sort_by = filters.sort_by;
  if (filters.sort_order) params.sort_order = filters.sort_order;
  params.page = filters.page || 1;
  params.limit = filters.limit || 20;
  return params;
};

const fetchBuckets = async (filters) => {
  const res = await axios.get(API_URLS.BUCKETS, {
    headers: headers(),
    params: buildListParams(filters),
  });
  const payload = res?.data?.data || {};
  return {
    items: payload.items || [],
    pagination:
      payload.pagination || { page: 1, limit: filters.limit || 20, total: 0, totalPages: 0 },
  };
};

const fetchBucketById = async (id) => {
  const res = await axios.get(
    `${API_URLS.BUCKETS}/${encodeURIComponent(String(id))}`,
    { headers: headers() }
  );
  return res?.data?.data || null;
};

const createBucket = async (payload) => {
  const res = await axios.post(API_URLS.BUCKETS, payload, { headers: headers() });
  return res?.data?.data || null;
};

const updateBucket = async (id, patch) => {
  const res = await axios.put(
    `${API_URLS.BUCKETS}/${encodeURIComponent(String(id))}`,
    patch,
    { headers: headers() }
  );
  return res?.data?.data || null;
};

const deleteBucket = async (id) => {
  const res = await axios.delete(
    `${API_URLS.BUCKETS}/${encodeURIComponent(String(id))}`,
    { headers: headers() }
  );
  return res?.data?.data || null;
};

const apiHelpers = {
  fetchBuckets,
  fetchBucketById,
  createBucket,
  updateBucket,
  deleteBucket,
  mapError,
};

export default apiHelpers;
